import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useEffect, useMemo, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { changeIframeOnClick } from '../../../../../../../helper/Helpers';

function BottomBar_1({ item, activeThemePageId }) {
  const customization = staticComponentValueConverter(item?.customization);
  const [activeBottomBar, setActiveBottomBar] = useState(0);
  const bottomBarFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);
  const bottomBarFilterActive = useMemo(
    () => HexToHueConverter(customization?.selectedIconColor),
    [customization?.selectedIconColor],
  );

  useEffect(() => {
    const pageId = activeThemePageId;
    const pageIdIndex = customization?.items?.findIndex(item => {
      const pointTo = item?.pointTo?.pointTo;
      if (pointTo?.includes(pageId)) {
        return item;
      }
    });
    if (pageIdIndex !== -1) {
      return setActiveBottomBar(pageIdIndex);
    }
    const pageMainIndex = customization?.items?.findIndex(item => {
      const pointTo = item?.pointTo?.pointTo;
      if (pointTo?.includes('Main')) {
        return item;
      }
    });
    setActiveBottomBar(pageMainIndex > -1 ? pageMainIndex : 0);
  }, [activeThemePageId]);
  return (
    <div
      id="bottomBar"
      className="shrink-0 w-full grid grid-cols-5 relative"
      style={{
        backgroundColor: customization?.backgroundColor,
        borderBottomRightRadius: customization?.bottomRadius,
        borderBottomLeftRadius: customization?.bottomRadius,
      }}
    >
      {customization?.items?.map((bottomBarItem, index) => {
        return (
          <div
            class="col-span-1 flex justify-center py-2  cursor-pointer  z-[20] flex-col"
            style={{ flexDirection: customization?.labelLocation ? 'column' : 'column-reverse' }}
            onClick={() => {
              changeIframeOnClick(bottomBarItem?.pointTo?.pointTo)
              setActiveBottomBar(index);
            }}
          >
            <div
              className="text-[10px]"
              style={{
                color: index === activeBottomBar ? customization?.selectedIconColor : customization?.iconColor,
                fontWeight: 'bold',
              }}
            >
              {bottomBarItem?.name}
            </div>
            <img
              style={{ filter: index === activeBottomBar ? bottomBarFilterActive : bottomBarFilter }}
              className="m-auto w-[22px] h-[22px] 2xl:h-[21.84px] 2xl:w-[21.84px]"
              src={bottomBarItem?.url}
              alt={'bottom bar icon'}
            />
          </div>
        );
      })}
    </div>
  );
}
export default BottomBar_1;
